

import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class OfficerMap extends kr.Component {
    init()
    {
        this.map = null;
        this.lat = this.$element.getAttribute('data-pin-lat');
        this.lng = this.$element.getAttribute('data-pin-lng');

        if (!this.lat || !this.lng) {
            return false;
        }

        this.app.addJs('https://unpkg.com/leaflet@1.7.1/dist/leaflet.js', true, this._callback.bind(this));
        this.app.addCss('https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');
    }

    bind()
    {
        this.map = window.L.map(this.$element, {
            center: [this.lat, this.lng],
            zoom: 11
        });
        L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
            maxZoom: 18
        })
        .addTo(this.map);

        const marker = L.marker([this.lat, this.lng]).addTo(this.map);
        //this.mapMarkers.push(marker);
    }

    _callback()
    {
        this.bind();
    }

}

kr.registerComponent('.js-officersmap', {
    component: OfficerMap
});
